import React from "react";

export default function InfoTooltip({ items }: any) {
  const optionalproduct = (optionalproduct: any) => {
    let items: any = [];
    optionalproduct?.map((productitems: any, i: number) => {
      items.push(productitems.product.displayTitle);
      return items.push(" or ");
    });
    items.pop();
    return items;
  };
  return (
    <>
      {items.__component === "info.info-component" ? (
        <li>
          {items.label}{" "}
          <span className="tooltips">
            i
            <span
              className="tooltiptexts"
              dangerouslySetInnerHTML={{
                __html: items.description,
              }}
            ></span>
          </span>
        </li>
      ) : (
        <li>
          {items.product?.title != null
            ? items.product?.title
            : optionalproduct(items.OptionalProducts)}{" "}
          {items.quantity != null ? "(" + items.quantity + ")" : null}
        </li>
      )}
    </>
  );
}
